import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../../../axios-order";
import { useHistory } from "react-router-dom";
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box, Typography,
    IconButton,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import { Modal } from "@mui/material";
import { ValidatorForm } from "react-material-ui-form-validator";
import Inputfield from "../../../../components/ui/inputField";
import { useRef } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import DescriptionIcon from '@mui/icons-material/Description';
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { canRead, canWrite } from "../../../../utils/privilegeUtils";

const GstPayablityReport = () => {
    const { reconId } = useParams();
    let history = useHistory();
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");
    const [fileNowDialogOpen, setFileNowDialogOpen] = useState(false);
    const [openEstablishConnectionDrawer, setOpenEstablishConnectionDrawer] = useState(false);
    const [openOTPModal, setOpenOTPModal] = useState(false);
    const [username, setUsername] = useState("");
    const [auth_otp, setAuthOTP] = useState("");
    const [otpApiData, setOtpApiData] = useState({});
    const [authAPiResData, setAuthApiResData] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const [establishConnectionButton, setEstablishConnectionButton] = useState("button-outlined-secondary");
    const form = useRef("form");
    const [fileNowData, setFileNowData] = useState([]);

    // Sample dialog table data - replace with your actual data
    // const [fileNowData, setFileNowData] = useState([
    //     { filingStatus: "Pending", report: "GST Report Q1", excelReport: "gst_q1.xlsx" },
    //     { filingStatus: "Filed", report: "GST Report Q2", excelReport: "gst_q2.xlsx" },
    //     { filingStatus: "In Progress", report: "GST Report Q3", excelReport: "gst_q3.xlsx" },
    // ]);

    useEffect(() => {
        getPayablityData();
    }, []);

    const handleChange = (index, field, value) => {
        const updatedData = [...data];
        updatedData[index][field] = value;
        setData(updatedData);
    };


    const handleRefresh = () => {
        handleLogFile();

    }


    const handleSnackbarOpen = (message, severity) => {
        setSnackbarOpen(true);
        setSnackbarSeverity(severity);
        setResponseMessage(message);


    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setSnackbarSeverity("success");
        setResponseMessage("");

    };


    const getPayablityData = () => {
        axios.get(`/get_computation_report_data_table2/${reconId}`)
            .then(res => {
                setData(res.data);
            })
            .catch(err => {
                setError(err.message || 'An error occurred');
            });
    };

    const handleSave = () => {
        const payLoadData = {
            'table3_data': data,
            'business_entity_id': localStorage.getItem("business_entity_id"),
            'summary_id': reconId
        }
        setLoading(true)
        axios.post('/generate_computation_table2', payLoadData)
            .then(response => {
                handleSnackbarOpen(response?.data?.message, 'success')
                setLoading(false)
                localStorage.setItem('is_confirm', response?.data?.is_confirm)
                getPayablityData()

            })
            .catch(error => {
                handleSnackbarOpen(error.response?.data?.message || 'An error occurred', 'error')
                setLoading(false)
            });
    };


    const handleLogFile = () => {
        setFileNowDialogOpen(true);
        axios.get(`/get_gst_computation_filing_log/${reconId}/${localStorage.getItem("business_entity_id")}`)
            .then(res => {
                setFileNowData(res.data.records || []);
            })
            .catch(err => {
                setError(err.message || 'An error occurred');
            });
    }

    const handleFileNow = () => {
        const payLoadData = {
            'gstin': localStorage.getItem('gst'),
            'business_entity_id': localStorage.getItem("business_entity_id"),
            'summary_id': reconId
        }
        setLoading(true)
        axios.post('/gst_computation_filing_save_3b', payLoadData)
            .then(response => {
                handleSnackbarOpen(response?.data?.message, 'success')
                setLoading(false)

            })
            .catch(error => {
                handleSnackbarOpen(error.response?.data?.message || 'An error occurred', 'error')
                setLoading(false)
            });
    };

    const closeEstablishConnectionDrawerHandler = () => {
        setOpenEstablishConnectionDrawer(false);
    };

    const closeOtpModalHandler = () => {
        setAuthOTP("");
        setOpenOTPModal(false);
    };

    const getOtpForAuthHandler = () => {
        const payload = {
            user_name: username,
            business_entity_id: localStorage.getItem("business_entity_id"),
        };

        axios.post("/vyana/send_otp", payload)
            .then((res) => {
                if (res.data.status === true) {
                    if (res.data.is_authenticated === true && res.data.is_otp_sent === false) {
                        setOpenOTPModal(false);
                        if (res.data.message === "Connection established.") {
                            setSuccessMessage(res.data.message);
                        }
                        handleSnackbarOpen(res.data.message, "success");
                        closeEstablishConnectionDrawerHandler();
                    } else if (res.data.is_authenticated === false && res.data.is_otp_sent === true) {
                        closeEstablishConnectionDrawerHandler();
                        setOpenOTPModal(true);
                        handleSnackbarOpen(res.data.message, "success");
                    } else {
                        setOpenOTPModal(true);
                        setOtpApiData({
                            ...otpApiData,
                            transaction_id: res.data.transaction_id,
                            app_key: res.data.app_key,
                        });
                    }
                } else {
                    handleSnackbarOpen(res.data.error, "error");
                    setOpenOTPModal(false);
                    setEstablishConnectionButton("button-outlined-secondary");
                }
            })
            .catch((error) => {
                handleSnackbarOpen(error.response?.message || error.message, "error");
            });
    };

    const vyanaAuthHandler = () => {
        const payload = {
            user_name: username,
            business_entity_id: localStorage.getItem("business_entity_id"),
            app_key: otpApiData.app_key,
            transaction_id: otpApiData.transaction_id,
            otp: auth_otp,
        };

        axios.post("/vyana/authenticate", payload)
            .then((res) => {
                if (res.data.status === true) {
                    setOpenOTPModal(false);
                    setOpenEstablishConnectionDrawer(false);
                    setEstablishConnectionButton("button-connection-established");
                    setAuthApiResData({ ...authAPiResData, sek: res.data.sek, auth_token: res.data.auth_token });
                    handleSnackbarOpen(res.data.message, "success");
                    setUsername("");
                    setTimeout(() => {
                        setEstablishConnectionButton("button-outlined-secondary");
                    }, 300000);
                } else {
                    handleSnackbarOpen(res.data.error, "error");
                    setOpenOTPModal(true);
                    setEstablishConnectionButton("button-outlined-secondary");
                    setUsername("");
                }
            })
            .catch((error) => {
                setOpenOTPModal(true);
                setEstablishConnectionButton("button-outlined-secondary");
                setUsername("");
                handleSnackbarOpen(error.response?.message || error.message, "error");
            });
    };

    const handleFileNowDialogClose = () => {
        setFileNowDialogOpen(false);
    };

    // const handleDownload = (row) => {

    // }


    const handleDownload = (row) => {

        const payLoadData = {
            // 'summary_id': reconId,
            // 'business_entity_id': localStorage.getItem("business_entity_id"),
            'log_id': row.id,
        }
        const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `Gstr 3b-filing report.xlsx`;

        axios.post('/get_gst_computation_filing_log_report', payLoadData)
            .then((res) => {
                downloadBase64File(contentType, res?.data?.file, filename);


            }).catch((err) => {

            })
            .finally(() => {

            })
    }


    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    const formatFilingDate = (dateStr) => {
        if (!dateStr) return '-';
        const parts = dateStr.split(' ');
        const dateParts = parts[0].split('-');
        const day = dateParts[0];
        const month = dateParts[1];
        const year = dateParts[2];
        const time = parts[1];
        return new Date(`${year}-${month}-${day}T${time}`).toLocaleString('en-IN', {
            day: '2-digit', month: 'short', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    };

    return (
        <div className="gst-pay-wrap">
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

                .gst-pay-wrap {
                    --paper: #F8FAFC;
                    --paper-alt: #F4F7FD;
                    --card: #FFFFFF;
                    --ink: #0F172A;
                    --ink-hover: #274C99;
                    --ink-soft: #64748B;
                    --border: #E2E8F0;
                    --rule-gold: #2F5FBD;
                    --primary: #2F5FBD;
                    --primary-soft: #EEF2FF;
                    --seal-maroon: #DC2626;
                    font-family: 'Inter', sans-serif;
                    color: var(--ink);
                    background: var(--paper);
                    padding: 18px 22px 26px;
                    border-radius: 12px;
                }

                /* ---------- masthead ---------- */
                .gst-pay-masthead {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 24px;
                    padding: 16px 20px;
                    margin-bottom: 16px;
                    background: var(--card);
                    border: 1px solid var(--border);
                    border-radius: 12px;
                    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 10px rgba(15, 23, 42, 0.05);
                }
                .gst-pay-masthead-title {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }
                .gst-pay-masthead-title > svg.gst-pay-icon {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 38px;
                    height: 38px;
                    padding: 8px;
                    border-radius: 10px;
                    background: var(--primary-soft);
                    border: 1px solid #C7D2FE;
                    box-sizing: border-box;
                }
                .gst-pay-masthead h1 {
                    font-family: 'Inter', sans-serif;
                    font-weight: 700;
                    font-size: 1.25rem;
                    color: var(--ink);
                    margin: 0;
                }
                .gst-pay-masthead p {
                    margin: 2px 0 0;
                    font-size: 0.8rem;
                    color: var(--ink-soft);
                    font-style: normal;
                    font-family: 'Inter', sans-serif;
                }
                .gst-pay-icon { color: var(--primary) !important; font-size: 1.35rem !important; }

                .gst-pay-masthead-actions {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    flex-shrink: 0;
                }

                .gst-pay-back-btn {
                    background: var(--card) !important;
                    color: var(--ink-soft) !important;
                    border: 1px solid var(--border) !important;
                    border-radius: 9px !important;
                    text-transform: none !important;
                    font-family: 'Inter', sans-serif !important;
                    font-weight: 600 !important;
                    box-shadow: none !important;
                    padding: 8px 16px !important;
                }
                .gst-pay-back-btn:hover {
                    background: var(--paper-alt) !important;
                    color: var(--ink) !important;
                }

                /* ---------- connection button row ---------- */
                .gst-connect-row {
                    display: flex;
                    justify-content: flex-end;
                    margin-bottom: 16px;
                }
                .gst-pay-wrap .gst-connect-btn {
                    border-radius: 9px !important;
                    font-family: 'Inter', sans-serif !important;
                    font-weight: 600 !important;
                    text-transform: none !important;
                    letter-spacing: 0.1px;
                    padding: 8px 18px;
                    border: 1px solid var(--primary) !important;
                }

                /* ---------- table card ---------- */
                .gst-pay-table-card {
                    border: 1px solid var(--border);
                    border-radius: 14px;
                    background: var(--card);
                    margin-bottom: 6px;
                    overflow: hidden;
                    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.05);
                }
                table.gst-pay-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-variant-numeric: tabular-nums;
                }
                .gst-pay-table thead th {
                    position: sticky;
                    top: 0;
                    background: var(--primary) !important;
                    color: #ffffff !important;
                    font-family: 'Inter', sans-serif;
                    font-weight: 600;
                    font-size: 0.78rem;
                    text-align: right;
                    padding: 11px 14px;
                    border-bottom: none !important;
                }
                .gst-pay-table thead th:first-child { text-align: left; }
                .gst-pay-table td {
                    padding: 10px 14px;
                    font-size: 0.87rem;
                    border-bottom: 1px solid var(--border);
                    color: var(--ink);
                }
                .gst-pay-table td:first-child {
                    color: var(--ink-soft);
                    font-weight: 500;
                }
                .gst-pay-table tbody tr:nth-of-type(even) td { background: var(--paper-alt); }
                .gst-pay-table tbody tr:hover td { background: #EAF0FC; }
                .gst-currency-symbol {
                    color: var(--ink-soft);
                    margin-right: 4px;
                    font-family: 'Inter', sans-serif;
                }
                .gst-pay-field {
                    width: 55%;
                    background: var(--card);
                    border: 1px solid var(--border);
                    border-radius: 6px;
                    text-align: right;
                    font-family: 'Inter', sans-serif;
                    font-weight: 500;
                    font-variant-numeric: tabular-nums;
                    color: var(--ink);
                    padding: 5px 8px;
                    outline: none;
                    transition: border-color 0.15s ease, box-shadow 0.15s ease;
                }
                .gst-pay-field:hover { border-color: #C7D2FE; }
                .gst-pay-field:focus {
                    border-color: var(--primary);
                    box-shadow: 0 0 0 3px var(--primary-soft);
                }

                /* ---------- bottom action buttons ---------- */
                .gst-pay-actions {
                    display: flex;
                    justify-content: flex-end;
                    gap: 10px;
                    margin-top: 6px;
                }
                .gst-pay-wrap .gst-pay-btn-action {
                    border-radius: 9px !important;
                    text-transform: none !important;
                    font-family: 'Inter', sans-serif !important;
                    font-weight: 600 !important;
                    background: var(--primary) !important;
                    color: #ffffff !important;
                    box-shadow: none !important;
                    min-width: 120px !important;
                    height: 38px !important;
                }
                .gst-pay-wrap .gst-pay-btn-action:hover {
                    background: var(--ink-hover) !important;
                    box-shadow: none !important;
                }

                /* ---------- global rules for portaled Dialog / Modal content ----------
                   MUI Dialog/Modal render via a portal at the end of document.body,
                   so they sit outside .gst-pay-wrap in the DOM. These rules are
                   written as standalone classes (no wrapper ancestor) so they still
                   reach that content; each class is applied explicitly below. */
                .gst-dialog-title-ledger {
                    font-family: 'Inter', sans-serif !important;
                    font-weight: 700 !important;
                    color: #0F172A !important;
                }
                .gst-form-btn-primary {
                    background: #2F5FBD !important;
                    border-color: #2F5FBD !important;
                    font-family: 'Inter', sans-serif !important;
                    font-weight: 600 !important;
                    text-transform: none !important;
                    border-radius: 9px !important;
                }
                .gst-form-btn-outline {
                    color: #64748B !important;
                    border-color: #E2E8F0 !important;
                    background: #FFFFFF !important;
                    font-family: 'Inter', sans-serif !important;
                    font-weight: 600 !important;
                    text-transform: none !important;
                    border-radius: 9px !important;
                }
                .gst-log-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-family: 'Inter', sans-serif;
                }
                .gst-log-table th {
                    background: #2F5FBD !important;
                    color: #FFFFFF !important;
                    font-weight: 600;
                    font-size: 0.78rem;
                    text-align: left;
                    padding: 10px 12px;
                    border-bottom: none !important;
                }
                .gst-log-table td {
                    padding: 9px 12px;
                    font-size: 0.85rem;
                    border-bottom: 1px solid #E2E8F0;
                    color: #0F172A;
                }
                .gst-log-table tbody tr:hover td { background: #F4F7FD; }
                .gst-status-chip {
                    font-family: 'Inter', sans-serif;
                    font-weight: 600;
                    letter-spacing: 0.2px;
                    border-radius: 999px !important;
                }
            `}</style>

            <div className="gst-pay-masthead">
                <div className="gst-pay-masthead-title">
                    <ReceiptLongIcon className="gst-pay-icon" />
                    <div>
                        <h1>GST Payability Statement</h1>
                        <p>Net tax payable after adjusting available input credit</p>
                    </div>
                </div>
                <div className="gst-pay-masthead-actions">
                    {successMessage === "Connection established." ? (
                        <button
                            className="button-outlined-primary gst-connect-btn"
                            style={{ backgroundColor: "#2F5FBD", color: "#FFFFFF", borderColor: "#2F5FBD" }}
                        >
                            Connection Established
                        </button>
                    ) : (
                        <button
                            className="button-outlined-primary gst-connect-btn"
                            style={{ backgroundColor: "#FFFFFF", color: "#2F5FBD", borderColor: "#2F5FBD" }}
                            onClick={() => setOpenEstablishConnectionDrawer(true)}
                        >
                            {establishConnectionButton === "button-outlined-secondary"
                                ? "Establish Connection"
                                : "Connection Established"}
                        </button>
                    )}
                    <Button
                        variant="outlined"
                        className="gst-pay-back-btn"
                        onClick={() => history.goBack()}
                        startIcon={<ArrowBackIcon />}
                    >
                        Back
                    </Button>
                </div>
            </div>

            {/* Establish Connection Dialog */}
            <Dialog
                open={openEstablishConnectionDrawer}
                onClose={closeEstablishConnectionDrawerHandler}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: { borderRadius: 2, boxShadow: 24, p: 2, bgcolor: "#FFFFFF", border: "1px solid #E2E8F0", zIndex: 1300 }
                }}
            >
                <DialogTitle className="gst-dialog-title-ledger">Establish Connection</DialogTitle>
                <DialogContent>
                    <ValidatorForm
                        ref={form}
                        onSubmit={getOtpForAuthHandler}
                        onError={(errors) => console.log(errors)}
                    >
                        <Inputfield
                            textLabel="User Name"
                            inputType="text"
                            name="user_name"
                            value={username}
                            textOnchangeFunction={(e) => setUsername(e.target.value)}
                            requiredField="*"
                            validator={["required"]}
                            errorMsg={["This field is required"]}
                        />
                        <div className="mt-20">
                            <button className="button-primary gst-form-btn-primary" type="submit">Submit</button>
                            <button
                                className="button-outlined-secondary gst-form-btn-outline"
                                type="button"
                                onClick={closeEstablishConnectionDrawerHandler}
                            >
                                Close
                            </button>
                        </div>
                    </ValidatorForm>
                </DialogContent>
            </Dialog>

            {/* OTP Modal */}
            <Modal open={openOTPModal}>
                <Box sx={{
                    position: "absolute", top: "50%", left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400, bgcolor: "#FFFFFF",
                    borderRadius: '12px',
                    border: "1px solid #C7D2FE", boxShadow: 24, p: 4, zIndex: 1300
                }}>
                    <ValidatorForm
                        ref={form}
                        onSubmit={vyanaAuthHandler}
                        onError={(errors) => console.log(errors)}
                    >
                        <Inputfield
                            textLabel="OTP"
                            inputType="text"
                            name="OTP"
                            value={auth_otp}
                            textOnchangeFunction={(e) => setAuthOTP(e.target.value)}
                            requiredField="*"
                            validator={["required"]}
                            errorMsg={["This field is required"]}
                        />
                        <div className="mt-20">
                            <button className="button-primary gst-form-btn-primary" type="submit">Submit</button>
                            <button
                                className="button-outlined-secondary gst-form-btn-outline"
                                type="button"
                                onClick={closeOtpModalHandler}
                            >
                                Close
                            </button>
                        </div>
                    </ValidatorForm>
                </Box>
            </Modal>

            <div className="gst-pay-table-card">
                <div className="responsive-table" style={{ minHeight: (data && data.length > 0) && '54vh' }}>
                    <table className="custome-table gst-pay-table">
                        <thead>
                            <tr>
                                <th>Particulars</th>
                                <th>IGST</th>
                                <th>CGST</th>
                                <th>S/UTGST</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data ? (
                                data.length > 0 ? (
                                    data.map((row, index) => (
                                        <tr key={index}>
                                            <td>{row.particulars}</td>
                                            {row.particulars === "Opening ITC carried forward from prev month" ? (
                                                <>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <span className="gst-currency-symbol">₹</span>
                                                        {canWrite("GST COMPUTATION REPORT") ? <input
                                                            type="number"
                                                            value={row.igst}
                                                            onChange={(e) => handleChange(index, 'igst', e.target.value)}
                                                            step="0.01"
                                                            className="gst-pay-field"
                                                            onKeyDown={(e) => {
                                                                // Allow: numbers, decimal point, backspace, delete, arrow keys, tab
                                                                const allowedKeys = [
                                                                    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', '.'
                                                                ];
                                                                const isNumber = /[0-9]/.test(e.key);
                                                                if (!isNumber && !allowedKeys.includes(e.key)) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        /> : <span style={{ fontWeight: 'bold' }}>{row.igst}</span>}
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <span className="gst-currency-symbol">₹</span>
                                                        {canWrite("GST COMPUTATION REPORT") ? <input
                                                            type="number"
                                                            value={row.cgst}
                                                            onChange={(e) => handleChange(index, 'cgst', e.target.value)}
                                                            step="0.01"
                                                            className="gst-pay-field"
                                                            onKeyDown={(e) => {
                                                                // Allow: numbers, decimal point, backspace, delete, arrow keys, tab
                                                                const allowedKeys = [
                                                                    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', '.'
                                                                ];
                                                                const isNumber = /[0-9]/.test(e.key);
                                                                if (!isNumber && !allowedKeys.includes(e.key)) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        /> : <span style={{ fontWeight: 'bold' }}>{row.cgst}</span>}
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <span className="gst-currency-symbol">₹</span>
                                                        {canWrite("GST COMPUTATION REPORT") ? <input
                                                            type="number"
                                                            value={row.sgst}
                                                            onChange={(e) => handleChange(index, 'sgst', e.target.value)}
                                                            step="0.01"
                                                            className="gst-pay-field"
                                                            onKeyDown={(e) => {
                                                                // Allow: numbers, decimal point, backspace, delete, arrow keys, tab
                                                                const allowedKeys = [
                                                                    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', '.'
                                                                ];
                                                                const isNumber = /[0-9]/.test(e.key);
                                                                if (!isNumber && !allowedKeys.includes(e.key)) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        /> : <span style={{ fontWeight: 'bold' }}>{row.sgst}</span>}
                                                    </td>
                                                </>
                                            ) : (
                                                <>
                                                    <td style={{ textAlign: 'right' }}><span className="gst-currency-symbol">₹</span>{row.igst.toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}><span className="gst-currency-symbol">₹</span>{row.cgst.toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}><span className="gst-currency-symbol">₹</span>{row.sgst.toFixed(2)}</td>
                                                </>
                                            )}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td style={{ color: "#DC2626" }} colSpan={4}>
                                            No data found!
                                        </td>
                                    </tr>
                                )
                            ) : (
                                <tr>
                                    <td colSpan={4}>Loading... Please wait...</td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>
            </div>

            <div className="gst-pay-actions">
                <LoadingButton
                    className="gst-pay-btn-action"
                    onClick={handleLogFile}
                    loading={loading}
                    loadingPosition="start"
                    startIcon={<DescriptionIcon />}
                    variant="contained"
                >
                    <span>Log File</span>
                </LoadingButton>
                <LoadingButton
                    className="gst-pay-btn-action"
                    onClick={handleFileNow}
                    loading={loading}
                    loadingPosition="start"
                    startIcon={<SendIcon />}
                    variant="contained"
                >
                    <span>File Now</span>
                </LoadingButton>
                   {canWrite("GST COMPUTATION REPORT") && (
                <LoadingButton
                    className="gst-pay-btn-action"
                    onClick={handleSave}
                    loading={loading}
                    loadingPosition="start"
                    startIcon={<SaveIcon />}
                    variant="contained"
                >
                    <span>Save</span>
                </LoadingButton>
                 )}
            </div>

            {/* File Now Dialog */}
            {/* File Now Dialog */}
            <Dialog
                open={fileNowDialogOpen}
                onClose={handleFileNowDialogClose}
                fullWidth
                maxWidth="xl"
                PaperProps={{
                    sx: { borderRadius: 2, boxShadow: 24, px: 2, py: 1, marginLeft: 8, bgcolor: '#FFFFFF', border: '1px solid #E2E8F0' }
                }}
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1, borderBottom: '1px solid #E2E8F0' }}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="h6" className="gst-dialog-title-ledger">Log — GST Payability Report</Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <IconButton onClick={handleRefresh} size="small" title="Refresh" sx={{ color: '#2F5FBD' }}>
                            <RefreshIcon />
                        </IconButton>
                        <IconButton onClick={handleFileNowDialogClose} size="small" sx={{ color: '#2F5FBD' }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>

                <DialogContent dividers sx={{ px: 3, py: 2, overflow: 'hidden' }}>
                    <div style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'auto' }}>
                        <table className="gst-log-table">
                            <thead>
                                <tr>
                                    <th style={{ position: 'sticky', top: 0, zIndex: 1 }}>Filing Date</th>
                                    <th style={{ position: 'sticky', top: 0, zIndex: 1 }}>Filing Status</th>
                                    <th style={{ position: 'sticky', top: 0, zIndex: 1 }}>Report</th>
                                    <th style={{ position: 'sticky', top: 0, zIndex: 1 }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {fileNowData.length > 0 ? (
                                    fileNowData.map((row, index) => {
                                        // Parse report JSON
                                        let parsedReport = {};
                                        try {
                                            parsedReport = JSON.parse(row.report || '{}');
                                        } catch (e) {
                                            parsedReport = {};
                                        }

                                        // Status color
                                        const statusColor = {
                                            'Pass': '#16A34A',
                                            'Fail': '#DC2626',
                                            'In-progress': '#D97706',
                                            'Pending': '#2F5FBD',
                                        }[row.status] || '#64748B';

                                        return (
                                            <tr key={index}>
                                                <td>{formatFilingDate(row.filing_date)}</td>
                                                <td>
                                                    <span className="gst-status-chip" style={{
                                                        color: statusColor,
                                                        padding: '2px 10px',
                                                        borderRadius: '999px',
                                                        backgroundColor: statusColor + '14',
                                                        border: `1px solid ${statusColor}`,
                                                        fontSize: '12px'
                                                    }}>
                                                        {row.status}
                                                    </span>
                                                </td>
                                                <td>
                                                    <VisibilityIcon
                                                        style={{
                                                            cursor: 'pointer',
                                                            color: row.status === 'Fail' ? '#DC2626' : '#2F5FBD'
                                                        }}
                                                        onClick={() => {
                                                            let parsedReport = {};
                                                            try {
                                                                parsedReport = JSON.parse(row.report || '{}');
                                                            } catch (e) {
                                                                parsedReport = {};
                                                            }

                                                            const errorMsg = parsedReport.error
                                                                ? (typeof parsedReport.error === 'object'
                                                                    ? parsedReport.error?.message || JSON.stringify(parsedReport.error)
                                                                    : parsedReport.error)
                                                                : null;

                                                            const msg = parsedReport.ack_num
                                                                ? `Ack No: ${parsedReport.ack_num} | Ref ID: ${parsedReport.reference_id || '-'}`
                                                                : errorMsg
                                                                    ? `Error: ${errorMsg}`
                                                                    : parsedReport.reference_id
                                                                        ? `Ref ID: ${parsedReport.reference_id}`
                                                                        : row.action  
                                                                            ? row.action
                                                                            : '';

                                                            const severity = parsedReport.error ? 'error' : 'success';
                                                            handleSnackbarOpen(msg, severity);
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <DownloadIcon
                                                        style={{
                                                            cursor: row.status === 'Pass' ? 'pointer' : 'not-allowed',
                                                            color: row.status === 'Pass' ? '#2F5FBD' : '#bdbdbd',
                                                            opacity: row.status === 'Pass' ? 1 : 0.5
                                                        }}
                                                        onClick={() => {
                                                            if (row.status === 'Pass') handleDownload(row);
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: 'center', color: '#DC2626' }}>No data found!</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </DialogContent>

                <DialogActions sx={{ px: 3, py: 2 }}>
                    <Button variant="outlined" className="gst-form-btn-outline" onClick={handleFileNowDialogClose}>Close</Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                open={snackbarOpen}
                autoHideDuration={5000}
                onClose={handleSnackbarClose}
                style={{ maxWidth: '25%' }}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                    style={{
                        fontFamily: "'Inter', sans-serif",
                        backgroundColor: snackbarSeverity === 'success' ? '#16A34A' : '#DC2626',
                        borderRadius: '9px'
                    }}
                >
                    {responseMessage}
                    {message}
                </MuiAlert>
            </Snackbar>
        </div>
    );
}

export default GstPayablityReport;